import { Button, Flex, Image, Box, Stack } from "@chakra-ui/react";
import ResetSuccessSVG from "@root/assets/images/resetSuccessSVG.svg";
import { GreenTickIcon } from "@root/assets/icons/greenTickIcon";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ResetSuccessHeading,
  ResetSuccessTopHeading,
  FormContainer,
} from "./styles";
import { useTranslation } from "react-i18next";
import { ROUTE_NAMES } from "@root/constants";
import { KPSLogoBig } from "@root/assets/icons";
import {
  AuthHeading,
  AuthSubheading,
  AuthButton,
} from "@root/commonStyles/commonStyle";

export const ResetSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  return (
    <Flex minHeight="100vh" alignItems="center" justifyContent="center">
      <Stack justifyContent="center">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="16px"
          width="100%"
          maxWidth="450px" // Add this line
        >
          <GreenTickIcon />
          <AuthHeading mt={"16px"} fontSize="40px" fontWeight={700}>
            {t("resetPassword.resetSuccess")}
          </AuthHeading>
          <AuthSubheading
            mb={"40px"}
            fontSize="18px"
            fontWeight={400}
            color="#5C6670"
          >
            {t("resetPassword.resetSuccessSubtitle")}{" "}
            {t("resetPassword.resetSuccessSubtitle2")}
          </AuthSubheading>
        </Box>

        <Flex alignItems={"center"} width={"100%"}>
          <AuthButton
            onClick={() => navigate(ROUTE_NAMES.LOGIN)}
            type="submit"
            width={"100%"}
          >
            {t("resetPassword.continueToLogin")}
          </AuthButton>
        </Flex>
      </Stack>
    </Flex>
  );
};
